import { render, staticRenderFns } from "./WorkEducation.vue?vue&type=template&id=28ec30d6&scoped=true&"
import script from "./WorkEducation.vue?vue&type=script&lang=ts&"
export * from "./WorkEducation.vue?vue&type=script&lang=ts&"
import style0 from "./WorkEducation.vue?vue&type=style&index=0&id=28ec30d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec30d6",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCheckbox});
